import React from 'react';
import PropTypes from 'prop-types';
import Footer from '../Footer/FooterContainer';
import FinancialPlanHeader from '../FinancialPlanHeaderView';
import ActionStepsV2 from '../ActionStepsV2/ActionStepsV2Container';
import DebtManagementChart from '../../DebtManagementChart/DebtManagementChartContainer';
import Explanations from '../Explanations/ExplanationsContainer';
import { ASSUMPTIONS, OVERVIEW } from '../Explanations/ExplanationsConst';
import AssumptionsSectionView from '../Components/AssumptionsTable';
import debtManagementAssumptionsLabelMap from './DebtManagementAssumptionsConst';
import GeneralAssumptionsView from '../GeneralAssumptions';
import { Tasks } from '../../FinancialPlanOPL/Goals/components/Tasks/Tasks';

class DebtManagementView extends React.Component {
  componentDidMount() {
    if (this.props.isSubGoal) {
      const { clientId, updateGoalViewState, goalId } = this.props;

      updateGoalViewState(goalId, clientId);
    }
  }

  componentDidUpdate(prevProps) {
    const { isSubGoal, selectedSection } = this.props;

    if (isSubGoal) {
      const { clientId, updateGoalViewState, goalId } = prevProps;

      // Prevent infinite loop
      if (selectedSection !== OVERVIEW) {
        updateGoalViewState(goalId, clientId);
      }
    }
  }

  render() {
    const {
      chartData,
      chartTitle,
      clientId,
      data,
      fpId,
      isPrint,
      isCurrentPlan,
      selectedSection,
      debtManagementAssumptions,
      hasGoal,
      goal,
      goalId,
      isSubGoal,
      selectedGoal,
    } = this.props;

    if (!hasGoal) {
      return null;
    }

    return (
      <div className="NewFinancialPlan_debtManagement" css="page-break-inside: avoid">
        <div
          className={`NewFinancialPlan_header
              ${!this.props.showCalibration ? ' hide-calibration-button' : ''}
          `}
        >
          <FinancialPlanHeader
            {...this.props}
            hideOldDescription={false}
            hideTrackIndicator={selectedSection === ASSUMPTIONS && isPrint}
          />
        </div>
        <section className="calibration" />
        {!isPrint && <Explanations clientId={clientId} />}

        {selectedSection === OVERVIEW && (
          <section>
            <DebtManagementChart
              isPrint={isPrint}
              clientId={clientId}
              chartData={chartData}
              chartTitle={chartTitle}
              isCurrentPlan={isCurrentPlan}
              loaded
            />
          </section>
        )}
        {selectedSection === ASSUMPTIONS && !isPrint && (
          <div className="assumptions-container">
            <AssumptionsSectionView
              title="Debt Management Goal Assumptions"
              valuesList={debtManagementAssumptions}
              labelList={debtManagementAssumptionsLabelMap}
            />
            <br />
            <GeneralAssumptionsView clientId={clientId} />
          </div>
        )}

        {!isPrint && selectedSection !== ASSUMPTIONS && (
          <Tasks {...(isSubGoal ? { debtType: selectedGoal.DebtType } : {})} />
        )}

        {isPrint && selectedSection !== ASSUMPTIONS && (
          <ActionStepsV2 clientId={clientId} fpId={fpId} goal={goal} goalId={goalId} />
        )}

        {!isPrint && <Footer data={data} clientId={clientId} fpId={fpId} />}
      </div>
    );
  }
}

DebtManagementView.defaultProps = {
  calibration: null,
  isSubGoal: false,
  isPrint: false,
};

DebtManagementView.propTypes = {
  calibration: PropTypes.shape({}),
  clientId: PropTypes.string.isRequired,
  data: PropTypes.shape({}).isRequired,
  fpId: PropTypes.string.isRequired,
  goalId: PropTypes.string.isRequired,
  selectedGoal: PropTypes.shape({
    DebtType: PropTypes.number,
  }).isRequired,
  setReactCalibrationWidget: PropTypes.func.isRequired,
  chartData: PropTypes.shape({}).isRequired,
  chartTitle: PropTypes.string.isRequired,
  showCalibration: PropTypes.bool.isRequired,
  isPrint: PropTypes.bool,
  hasGoal: PropTypes.bool.isRequired,
  isCurrentPlan: PropTypes.bool.isRequired,
  debtManagementAssumptions: PropTypes.shape({}).isRequired,
  isSubGoal: PropTypes.bool,
  selectedSection: PropTypes.string.isRequired,
  updateGoalViewState: PropTypes.func.isRequired,
  goal: PropTypes.shape({}).isRequired,
};

export default DebtManagementView;
